import { useCurrentEnterpriseId } from '@mews-commander/core';
import { ServiceType, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { useLocalizeProperty } from '@mews/framework';

export const useGetServiceNamesByIdQuery = (serviceIds?: string[]) => {
    const currentEnterpriseId = useCurrentEnterpriseId();
    const lp = useLocalizeProperty();

    return useRepositorySuspenseQuery(
        'services',
        'getAll',
        {
            enterpriseIds: [currentEnterpriseId],
            serviceIds: serviceIds != null && serviceIds.length > 0 ? serviceIds : undefined,
        },
        {
            select: ({ services }) =>
                services
                    .filter((service) => service.data.discriminator === ServiceType.Bookable)
                    .reduce((acc: Record<string, string>, { names, id }) => ({ ...acc, [id]: lp(names) }), {}),
        }
    );
};
